import { fork } from 'redux-saga/effects';
import sessionSaga from './session/saga';
import playerSaga from './player/saga';

export default function* rootSaga() {
    yield fork(sessionSaga);
    yield fork(playerSaga);
}
